import { Component, ViewChild } from '@angular/core';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { ApiService } from 'app/api.service';
import { ModalEditProjectComponent } from 'app/modal/modal-edit-project/modal-edit-project.component';

@Component({
	selector: 'modal-quote-choose-project',
	templateUrl: './modal-quote-choose-project.component.html'
})
export class ModalQuoteChooseProjectComponent extends UIModalBaseComponent {

	@ViewChild(ModalEditProjectComponent) editProjectModal: ModalEditProjectComponent;

	projects;
	customerId;
	currencyId;
	selectedId = null;

	title;
	message;

	open(data: any) {
		this.customerId = data?.customerId;
		this.currencyId = data?.currencyId;

		// Prompting on acceptance is the original caller, so its wording stays the default. Anything
		// opening this from another context passes copy that fits it.
		this.title = data?.title || 'Your quote has been accepted!';
		this.message = data?.message || 'It\'s time to add it to a project and start invoicing.';

		this.refresh();
	}

	constructor(private api: ApiService) {
		super();
	}

	refresh() {
		this.api.project.listCustomerProjects(this.customerId, list => {
			// Only projects the quote can actually be assigned to: matching currency and not cancelled
			this.projects = list.filter(item =>
				item.currency_id === this.currencyId &&
				item.status !== 'cancelled'
			);

			if (this.selectedId && !this.projects.some(item => item.id === this.selectedId)) this.selectedId = null;

			this.modal.open();
		});
	}

	setProject() {
		this.modal.close(this.selectedId);
	}

	addProject() {
		if (this.customerId) {
			this.editProjectModal.open({
				customerId: this.customerId,
				currencyId: this.currencyId
			});
		}
	}

	editProjectModalClosed(data) {
		if (data && data !== 'deleted') {
			this.selectedId = data.id;
			this.refresh();
		}
	}

}
